import { useLoadScript } from '@react-google-maps/api'
import {
  InputLabel,
  InputLabelBlock,
  StyledInput
} from 'components/common/TextInput'
import { LoadedPostalAddressInput } from './LoadedPostalAddressInput'

const placesLibs = ['places' as const]

interface PostalAddressInputProps {
  inputLabel?: string
  placeholder?: string
  disabled?: boolean
}

export const PostalAddressInput = ({
  inputLabel,
  placeholder,
  disabled
}: PostalAddressInputProps) => {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY as string,
    libraries: placesLibs
  })

  return (
    <>
      {isLoaded ? (
        <LoadedPostalAddressInput
          inputLabel={inputLabel}
          placeholder={placeholder}
          disabled={disabled}
        />
      ) : (
        <InputLabelBlock fullSize={true}>
          {inputLabel && <InputLabel>{inputLabel}</InputLabel>}
          <StyledInput placeholder={placeholder} onChange={() => {}} />
        </InputLabelBlock>
      )}
    </>
  )
}
